import {
    Action,
    handleActions,
} from 'redux-actions';
import {GET_TEXT_ENUMS} from './LoginActions';

export const getTextEnums = (state: any, {payload}: Action<any>) => {
    return payload;
};

const DEFAULT_STATE = {};

const handlers = {
    [GET_TEXT_ENUMS]: getTextEnums,
};

export default handleActions(handlers, DEFAULT_STATE);
